import DataTable from 'components/Display/DataTable/DataTable'
import {Page, PageContent} from 'components/Page'
import {
    useDeleteDanceCollectionMutation,
    useGetDanceCollectionsQuery,
} from 'store/slices/api/danceCollectionsApi'

const DanceCollections = () => {
    return (
        <Page>
            <PageContent>
                <DataTable
                    confirmBeforeDelete
                    allowEdit
                    allowDelete
                    itemName="danceCollection"
                    paginationType="external"
                    useGetQuery={useGetDanceCollectionsQuery}
                    useDeleteMutation={useDeleteDanceCollectionMutation}
                />
            </PageContent>
        </Page>
    )
}

export default DanceCollections
